import { Component, HostListener, Input, OnInit } from '@angular/core';
import { SetDate } from 'src/app/shared/models/node';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-sample-date-to-remember',
  templateUrl: './sample-date-to-remember.component.html',
  styleUrls: ['./sample-date-to-remember.component.scss']
})
export class SampleDateToRememberComponent implements OnInit {

  @Input() block: any;
  @Input() padding: boolean = false;
  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.nodeService.viewportScroll(event);
  }

  constructor(
    public nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {}

}
